import React from 'react';
import { BarChart3, Clock, CheckCircle, XCircle, TrendingUp, Server } from 'lucide-react';
import { DnsStatistics } from '../types/dns';

interface StatisticsPanelProps {
  stats: DnsStatistics;
}

const StatisticsPanel: React.FC<StatisticsPanelProps> = ({ stats }) => {
  
  return (
    <div className="bg-white rounded-xl shadow-lg p-6">
      <h3 className="text-xl font-bold text-gray-800 mb-6 flex items-center">
        <BarChart3 className="w-6 h-6 mr-2 text-blue-600" />
        Statistics
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <div className="bg-blue-50 p-4 rounded-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Total Servers</p>
              <p className="text-2xl font-bold text-blue-600">{stats.total}</p>
            </div>
            <Server className="w-8 h-8 text-blue-500" />
          </div>
        </div>
        
        <div className="bg-green-50 p-4 rounded-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Working</p>
              <p className="text-2xl font-bold text-green-600">{stats.working}</p>
            </div>
            <CheckCircle className="w-8 h-8 text-green-500" />
          </div>
        </div>
        
        <div className="bg-red-50 p-4 rounded-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Failed</p>
              <p className="text-2xl font-bold text-red-600">{stats.failed}</p>
            </div>
            <XCircle className="w-8 h-8 text-red-500" />
          </div>
        </div>
        
        <div className="bg-purple-50 p-4 rounded-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Success Rate</p>
              <p className="text-2xl font-bold text-purple-600">{stats.successRate}%</p>
            </div>
            <TrendingUp className="w-8 h-8 text-purple-500" />
          </div>
        </div>
      </div>
      
      {stats.avgTime > 0 && (
        <div className="bg-gray-50 p-4 rounded-lg">
          <h4 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
            <Clock className="w-5 h-5 mr-2 text-gray-600" />
            Response Times
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="text-center">
              <p className="text-sm text-gray-600">Fastest</p>
              <p className="text-xl font-bold text-green-600">{stats.minTime}ms</p>
            </div>
            <div className="text-center">
              <p className="text-sm text-gray-600">Average</p>
              <p className="text-xl font-bold text-blue-600">{stats.avgTime}ms</p>
            </div>
            <div className="text-center">
              <p className="text-sm text-gray-600">Slowest</p>
              <p className="text-xl font-bold text-red-600">{stats.maxTime}ms</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StatisticsPanel;
